<template>
        <div class="dialogMain">
            <dl>
                <dt><span >*</span>上传apk：</dt>
                <!--:http-request="hashMd5"
                :data="fileData"-->
                <dd>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="'zcvrVideoApi/appMsg/uploadApk/'+session"
                            :before-upload="beforeAvatarUpload"
                            :on-remove="handleRemove"
                            :file-list="fileList"
                            :on-success="uploadSuccess"
                            :on-error="uploadError"
                            :on-change="handleChange"
                            :limit="2"
                            :auto-upload="false">
                        <!--<el-button size="small" type="primary">上传视频</el-button>-->
                        <el-button slot="trigger" size="small" type="primary">选取apk文件</el-button>
                        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传apk文件</el-button>
                        <span slot="tip" class="el-upload__tip tooltip">只能上传apk文件</span>
                    </el-upload>
                </dd>
            </dl>
            <dl>
                <dt><span class="checktip">*</span>版本号：</dt>
                <dd class="cf">
                    <el-input v-model="dialogData.version" placeholder="版本号"></el-input>
                </dd>
            </dl>
            <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="handleConfirm()":loading="loading" style="float:right">确 定</el-button>
		   </span>
        </div>
</template>

<script>
    export default {
        name: "appComponent",
        data() {
            return {
                loading: false,
                session: sessionStorage.getItem('sessionId'),
                fileList: [],
                dialogData: {},
            }
        },
        methods: {
            beforeAvatarUpload(file) {
                console.log(file.name.split('.'))
                var name = file.name.split('.')
                const isMP4 = name[name.length-1] === 'apk';

                if (!isMP4) {
                    this.$message.error('上传文件只能是 apk格式!');
                }
//		        this.hashMd5(file)
                return isMP4;
            },
            handleRemove(file, fileList){
                $('.el-upload-list').css('height','auto')
                this.dialogData.url = ""
            },
            handleChange(files, fileList){
//		    	console.log(fileList)
                this.fileList=[]
                this.fileList.push(fileList[fileList.length-1])
            },
            submitUpload() {
//		    	console.log(this.fileList)
                $('.el-upload-list').css('height',"29px")
                this.$refs.upload.submit();
            },
            uploadError(err, file, fileList) {
                this.$router.push({path: '/',query: ''})
            },
            uploadSuccess(response, file, fileList) {
//		    	console.log(response)
                if(response.msg=="ok"){
                    this.dialogData.url = response.data.url
                    this.dialogData.md5 = response.data.md5
                    var pakUrlName = this.dialogData.url.split("/")
                    this.fileList = [{
                        name: pakUrlName[pakUrlName.length-1]
                    }]
                }else{
                    this.$message({
                        type: 'error',
                        message: response.msg
                    });
                    if(response.msg=="该SessionId已经超时"){
                        this.$message.error("登录超时！请重新登录");
                        this.$router.push({path: '/',query: ''})
                    }
                }
            },
            getAppMsg() {
                this.$http.get("zcvrVideoApi/appMsg/inquiryApp",{emulateJson:true}).then(
                    (success)=>{
//		  				console.log(success)
                        if(success.body.msg!="ok"){
                            this.fileList = []
                            this.dialogData = {}
                            if(success.data.msg=="该SessionId已经超时"){
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/',query: ''})
                            }
                        }else {
                            if(success.body.data) {
                                this.dialogData = success.body.data
                                if(this.dialogData.url){
                                    var pakUrlName = this.dialogData.url.split("/")
                                    this.fileList = [{
                                        name: this.dialogData.url
                                    }]
                                }
                            }else{
                                this.fileList = []
                                this.dialogData = {}
                            }
                        }

                    },
                    (error)=>{
                        console.log("数据连接失败")
                    }
                )
            },
            handleConfirm(){
                var url = ""
                var pakUrl = this.dialogData.url
                if(pakUrl){
                    if(pakUrl.indexOf("http") != -1){
                        var pakUrl = pakUrl.split("/")
                        pakUrl = pakUrl[pakUrl.length-2]+"/"+pakUrl[pakUrl.length-1]
                    }
                }else{
                    this.$message.error("请上传apk文件");
                    return
                }
                var data = {
                    version: this.dialogData.version,
                    md5: this.dialogData.md5,
                    url: pakUrl
                }
                this.$http.post('zcvrVideoApi/appMsg/updateApp/'+this.session,data,{emulateJson:true}).then(
                    (success)=>{
//		  				console.log(success)
                        this.loading=false
                        if(success.data.msg=="ok"){
                            this.dialogVisible = false
                            this.getAppMsg()
                        }else {
                            this.$message({
                                message: success.data.msg,
                                type: 'error'
                            });
                            if(success.data.msg=="该SessionId已经超时"){
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/',query: ''})
                            }
                        }
                    },
                    (error)=>{
                        this.loading=false
                        this.$message.error("数据连接失败");
                    }
                )
            },
        },
        mounted(){
            this.getAppMsg()
        }
    }
</script>

<style scoped>
    .checktip{
        color: red;
    }
</style>
